import { render, staticRenderFns } from "./POIHighlights.vue?vue&type=template&id=028df012"
import script from "./POIHighlights.js?vue&type=script&lang=js&external"
export * from "./POIHighlights.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports